function setYMCounter(data) {
    const ym = window.ym

    if (!ym || !data.counter)
        return;

    if (!data.type)
        data.type = 'reachGoal';

    ym(data.counter, data.type, data.target);
}

export default (data) => { setYMCounter(data) }